<template>
  <div style="display: flex;
    flex-wrap: wrap;
    justify-content: center;">
    <div class="oins" style="width: 1920px;">
      <h3 style="width: 1920px; margin-bottom: 40px; margin-top: 40px;" name="second">试用申请</h3>
      <el-form ref="form" :rules="rules" :model="form" class="formsds" label-width="80px">
        <el-row>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="form.companyName" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="iphone">
            <el-input v-model="form.iphone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
          </el-form-item>
          <el-form-item label="具体要求" prop="desc">
            <el-input type="textarea" v-model="form.desc" placeholder="请输入具体要求"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 208px;height: 40px;" type="primary" @click="submitForm('form')">立即提交</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div style="background-color: #fafafc; width: 1920px; height: 50px;">

    </div>
  </div>
</template>
<script>

import request from '../api/request.js'
export default {
  name: 'Fruit',
  data() {
    return {
      activeName: 'second',
      form: {
        name: '',
        companyName: '',
        iphone: '',
        email: '',
        desc: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
        ],
        iphone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
        ],
        desc: [
          { required: true, message: '请输入具体要求', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await request.request({
            method: "post",
            url: "/pc/pcusers/mdm/pcuser/login",
            data: { ...this.form }
          })
          this.data = res.data
          this.$message({
            message: '恭喜你，提交成功！！！',
            offset: 100,
            type: 'success'
          });
          this.resetForm('form')
        } else {
          this.$message({
            message: '提交失败',
            offset: 100,
            type: 'error'
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.spajs {
  text-align: left;
  width: auto;
  line-height: 38px;
  padding-left: 40px;
  color: #333;
}

.oins {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  /* margin-top: 200px; */
  margin-top: 65px;
}

.formsds {
  width: 502px;
  margin-bottom: 60px;
}

.el-form-item {
  margin-bottom: 22px;
}
</style>